import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="m-2 p-2 rounded-full bg-opacity-20 backdrop-blur-sm
        border border-opacity-20 hover:bg-opacity-30 transition-all duration-300
        flex items-center justify-center"
      style={{
        backgroundColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
        borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'
      }}
    >
      {theme === 'dark' ? (
        <Sun className="w-6 h-6" style={{ color: 'var(--text-primary)' }} />
      ) : (
        <Moon className="w-6 h-6" style={{ color: 'var(--text-primary)' }} />
      )}
      <span className="sr-only">تغییر تم</span>
    </button>
  );
};

export default ThemeToggle;